// extracted by mini-css-extract-plugin
module.exports = {"root":"TextBlockForm_root__209tF","wysiwygControl":"TextBlockForm_wysiwygControl__DRToM","wysiwygLabel":"TextBlockForm_wysiwygLabel__3S-NL"};